<template>
    <div :style="cssProps">
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white">
                        <b-breadcrumb :items="items"></b-breadcrumb>
                    </h1>
                </div>
            </div>
        </base-header>
        <div class="text-center" v-if="busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow py-5">
                        <div class="col-lg-12">
                            <b-table
                                ref="reportDelivery"
                                show-empty
                                responsive
                                :items="detailList"
                                :fields="fields"
                                :per-page="pagination.pageSize"
                                :busy="busy"
                                selectable
                                select-mode="multi"
                                class="scroll-bar-pop text-center"
                                empty-text="ไม่มีข้อมูลผู้ใช้"
                                empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                            >
                                <template slot="action" slot-scope="data">
                                    <b-button size="sm" variant="success" @click="importExcel(data.item)">ดาวน์โหลดรายละเอียด</b-button>
                                    <b-button size="sm" v-if="type == '1'" variant="warning" @click="fnGetSettlementInvoice(data.item.id)">ดาวน์โหลดใบเสร็จ</b-button>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {hexToRgbA} from "@/plugins/hexColor";
import moment from "moment";
import {dayInvoiceList, getInvoice} from "@/api/monthReceipt";

export default {
    name: "",
    data() {
        return {
            fields: [
                {
                    key: 'invoiceDate',
                    label: 'วันที่',
                    sortable: true
                },
                {
                    key: 'invoiceType',
                    label: 'ประเภท',
                    sortable: true
                },
                {
                    key: 'invoiceNum',
                    label: 'หมายเลขใบเสร็จ',
                    sortable: true
                },
                {
                    key: 'freightCount',
                    label: 'จำนวนพัสดุ',
                    sortable: true
                },
                {
                    key: 'totalFee',
                    label: 'ค่าบริการทั้งหมด',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'ดำเนินการ',
                    class: 'text-center'
                }
            ],
            detailList:[],
            type:'0',
            pagination: {
                pageIndex: 1,
                pageSize: 10,
                total: 0
            },
            busy: false,
            items: [
                {
                    text: '月度回执',
                    href: '/monthReceipt'
                },
                {
                    text: '回执',
                    active: true
                }
            ]
        }
    },
    created() {

    },
    mounted() {
        console.log(this.$route.query.month)
        this.type = this.$route.query.type
        this.month = this.$route.query.month
        this.items[1].text = '回执' + this.leaveMonth(this.$route.query.month)
        this.getDayInvoiceList()
    },
    methods: {
        fnGetSettlementInvoice(id){
            getInvoice({
                id: id
            }).then(res => {
                console.log(res, '123123')
                window.open(res.data.url)
            })
    },
        importExcel(row) {
            if (row.agentExcelUrl) {
                window.open(row.agentExcelUrl)
            } else {
                this.$message.error('ไม่มีข้อมูล')
            }
        },
         getDayInvoiceList(){
            dayInvoiceList({
                month: this.month ||'',
                pageIndex: this.pagination.pageIndex,
                pageSize: this.pagination.pageSize,
            }).then(res => {
                this.detailList = res.data.records
                this.pagination = {
                    pageIndex: res.data.current,
                    pageSize: res.data.size,
                    total: res.data.total,
                }
            })

        },
        leaveMonth(value) {
            return moment(value).format('YYYY-MM');
        },
    },
    computed: {
        cssProps() {
            return {
                '--bg-hover-color': hexToRgbA('#11cdef', 0.7),
                '--bg-color': '#11cdef',
            }
        }
    }
};
</script>
<style scoped>

</style>
